export default __webpack_public_path__ + "83307ba513fc1fb8c114efde9a39c8c6.png";